<!-- @format -->

<template>
	<div class="row pb--4">
		<div class="col-12 col-xs-12 pt--2">
			<div class="accordion bdr--light-gray accordion--arrows">
				<div class="accordion__item bdr__top--light-gray" data-accordion-type="default"
					v-for="(acc, index) in accordions" :key="acc.title">
					<button :class="{ 'accordion__header--active': acc.display }" :id="'acc' + index"
						@click="acc.display = !acc.display" class="accordion__header txt--md txt--strong">
						{{ acc.title }}
					</button>
					<div class="accordion__content wysiwyg" :aria-labelledby="'acc' + index"
						:class="{ 'accordion__content--active active': acc.display }" v-html="acc.content"
						@click.stop.prevent="handleClick"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Content',
	methods: {
		handleClick(e) {
			if (e.target.matches('a')) {
				let url = e.target.href;
				let target = e.target.target == '_blank' ? '_blank' : '_self';
				let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
				var isnativeapp = document.getElementById('isnativeapp');
				if (isnativeapp === undefined || isnativeapp === null) {
					window.open(url, target);
				} else {
					if (target == '_blank') {
						let data = { title: '', nodeid: dataId, href: url, target: target };
						window.Native('dataCallback', data);
					}
				}
			}
		},
	},
	data: function () {
		return {
			accordions: [
				{
					display: false,
					title: 'Guidance',
					content: `
						<p>
								The <a href="https://www.sign.ac.uk/media/1048/sign158.pdf" target="_blank">British guideline on the management of asthma</a> is produced jointly by SIGN and the British Thoracic Society. It covers diagnosis and management of asthma in adults and children.
						</p>
						<p>
							This 2019 version of the guideline includes information on predicting future risk of asthma attacks, 
							pharmacological management of asthma, supported self-management, non-pharmacological management of asthma, and management of acute asthma in adults and children. 
							It also includes a checklist of information for patients and carers.
						</p>
						<p> This guideline recommends use of the ACQ5 or other tools for measurement of symptomatic asthma control.</p>
						<p>A <a href="https://www.sign.ac.uk/media/1383/qrg158.pdf" target="_blank">quick reference guide</a> is available.</p>
						<h3 class="txt--lg">Other relevant guidelines</h3>
						<p>The <a href="https://www.nice.org.uk/guidance/ng80" target="_blank">National Institute for Clinical Excellence (NICE) Guideline NG80 Asthma: diagnosis, monitoring and chronic asthma management</a>. Published November 2017; updated February 2020.</p>
						<ul>
								<li>This guideline covers diagnosing, monitoring and managing asthma in adults, young people and children. It aims to improve the accuracy of diagnosis, help people to control their asthma and reduce the risk of asthma attacks. It does not cover managing severe asthma or acute asthma attacks.</li>
								<li>In February 2020, NICE reviewed the <a href="https://www.nice.org.uk/guidance/ng80/evidence/evidence-review-february-2020-7079862637?tab=evidence" target="_blank">evidence for increasing the dose of inhaled corticosteroids within a self-management programme in children and young people with asthma</a>. This resulted in updating the advice on <a href="https://www.nice.org.uk/guidance/ng80/chapter/Recommendations" target="_blank">self-management</a> for children and young people with deteriorating asthma control.</li>
						</ul>
						<p><strong>The <a href="https://ginasthma.org/wp-content/uploads/2020/04/Main-pocket-guide_2020_04_03-final-wms.pdf" target="_blank">Global Initiative for Asthma pocket guide</a></strong> (2020)</p>
						<ul>
								<li>The Global Initiative for Asthma (GINA) regularly publishes and annually updates a global strategy for asthma management and prevention that forms the basis for many national guidelines. It covers diagnosis, assessment and management of asthma, including acute exacerbations. It recommends a 5-step approach for adjusting treatment for individual patient needs.</li>
						</ul>
					`,
				},
				{
					display: false,
					title: 'Patient information & self-management resources',
					content: `
						<p><a href="https://www.nhsinform.scot/illnesses-and-conditions/lungs-and-airways/asthma" target="_blank"><strong>NHS inform</strong> Asthma</a></p>
						<p><strong>SIGN booklets for patients</strong></p>
						<ul>
								<li><a href="https://www.sign.ac.uk/media/1142/pat158_adult.pdf" target="_blank">Managing asthma in adults patient booklet (PDF)</a></li>
								<li><a href="https://www.sign.ac.uk/media/1141/pat158_child.pdf" target="_blank">Managing asthma in children patient booklet (PDF)</a></li>
								<li><a href="https://www.sign.ac.uk/media/1140/pat158_pregnancy.pdf" target="_blank">Asthma in pregnancy patient booklet (PDF)</a></li>
						</ul>
						<p><strong>Asthma UK</strong> – <a href="https://www.asthma.org.uk/advice/manage-your-asthma/" target="_blank">Managing your asthma</a></p>
						<p><strong>Asthma UK</strong> - <a href="https://www.asthma.org.uk/advice/" target="_blank">Health advice</a></p>
						<p><strong>NICE</strong> - <a href="https://www.nice.org.uk/guidance/ng80/informationforpublic" target="_blank">Asthma information for the public</a></p>
					`,
				},
				{
					display: true,
					title: 'Regulatory Information',
					content: `
						<h3>Regulatory Information</h3>
						<p>
						<strong>Product Name: </strong>Calculator Suite <br>
						<strong>Calculator Name: </strong>Asthma Control Questionnaire 5 (ACQ5)<br>
						<strong>Calculator Version: </strong> v2.1.0
						</p>  
						<div class="row">
						<div class="col-xs-4 col-lg-2">
							<img src="/img/cemark/shii.png" alt="InnoScot Health"/>
						</div>
						<div class="col-xs-8 col-lg-10">
							<p>
                  Innoscot Health<br>
									Suite 23, The Pentagon Centre<br>
									36 Washington Street<br>
									Glasgow<br>
									G3 8AZ
                </p>
						</div>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<p>
								<img src="/img/cemark/ukca.png" alt="UK Conformity Assessed"/>
								<!-- <img src="/img/cemark/ce.png" alt="CE marking"/> -->
								</p>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-4 col-lg-2">
								<img src="/img/cemark/warning.png" alt="InnoScot Health"/>
							</div>
							<div class="col-xs-8 col-lg-10">
								<p>
								<strong>Calculators are <u>not</u> intended to be used by members of the public as a substitute for professional advice.</strong>
								</p>
							</div>
						</div>
						
						<div class="row">
							<div class="col-xs-4 col-lg-2">
								<img src="/img/cemark/info.png" alt="More Information on Right Decision"/>
							</div>
							<div class="col-xs-8 col-lg-10">
								<p>
									<a href="https://rightdecision.scot.nhs.uk/quality-assurance-and-regulation/calculator-suite-instructions-for-use.pdf" target="_blank">Instructions for use</a>
								</p>
							</div>
						</div>
					`,
				},
			],
		};
	},
};
</script>
